import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import Menu from "../../components/Menu/Menu";
import { MenuProps } from "../../components/Menu/MenuTypes";
import { defaultMenuProps } from "../../constants/constants";
import FaqData from "../../components/Faq/FaqData/FaqData";
import { FaqDataProps } from "../../components/Faq/FaqData/FaqDataTypes";
import { getApiFaq } from "../../services/apiFaq";

const EditarFaq = (): React.ReactElement => {
  const urlParams = useParams();
  const [menuProps] = useState<MenuProps>(defaultMenuProps);
  const [faqData, setFaqData] = useState<FaqDataProps>({ faq: { _id: '' } });
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    getApiFaq({ _id: urlParams.faqId })
      .then((response: any) => {
        setFaqData({ faq: response });
        setLoaded(true);
      })
      .catch((error: any) => {
        console.log(error.message);
      });
  }, []);

  return (
    <React.Fragment>
      <div id="menu">
        <Menu items={menuProps.items} />
      </div>
      <div id="app-content">
        <header className="table-header mb-4">
          <h1>Editar FAQ</h1>
          <span></span>
        </header>
        {loaded && <FaqData faq={faqData.faq} />}
      </div>
    </React.Fragment>
  );
};

export default EditarFaq;
